export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-light-22e8fc345ebff17712b3592ebc515ce9.woff";